import {SergasSensor} from './sergasSensor';
import {HardwareDevice} from './hardwareDevice';

export class SergasDevice{
  constructor(
    public sergasDeviceId: string,
    public deviceName: string,
    public iPlaceId: string,
    public iPlaceName: string,
    public sectionId: string,
    public sectionName: string,
    public created: Date,
    public createdBy: string,
    public modified: Date,
    public modifiedBy: string,
    public sergasSensors: SergasSensor[],
    public hardwareDevices: HardwareDevice[]
  ){}
}
